import React, { memo, ReactNode } from "react";
import classNames from "classnames";

import { ReactComponent as ArrowLeft } from "../icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../icons/arrow-right.svg";

import styles from "./styles.module.scss";

export type CustomHeaderPropsType = {
  actions?: ReactNode | ReactNode[],
  monthDate: Date,
  classname?: string,
  decreaseMonth: (...args: any) => void,
  increaseMonth: (...args: any) => void,
  actionsClassname?: string,
  prevMonthButtonDisabled: boolean,
  nextMonthButtonDisabled: boolean,
}

export const CustomHeader = memo<CustomHeaderPropsType>(({
  actions,
  actionsClassname,
  monthDate,
  classname,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  return (
    <div className={classNames(classname, styles.root)}>
      <div className={styles.monthBlock}>
        <button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          className={styles.button}
        >
          <ArrowLeft />
        </button>
        <span className={styles.monthDate}>
          {new Intl.DateTimeFormat("en-US", { year: "numeric", month: "long" }).format(monthDate)}
        </span>
        <button
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          className={styles.button}
        >
          <ArrowRight />
        </button>
      </div>
      {
        actions &&
        <div className={classNames(styles.actions, actionsClassname)}>
          {actions}
        </div>
      }
    </div>
  );
});
